import React from 'react';
function TrackItem({ track, isActive, colour, isMuted, onToggleMute }) {
    return (React.createElement("div", { className: `flex items-center justify-between px-4 py-2 border-b border-gray-700  min-w-[280px]
      ${isActive ? 'bg-blue-900' : 'bg-gray-900'} hover:bg-gray-800`, style: { borderLeft: `4px solid ${colour}` } },
        React.createElement("span", { className: "text-orange-500 font-semibold" }, track.name),
        React.createElement("button", { onClick: onToggleMute, className: `text-sm px-2 py-1 rounded ${isMuted ? 'bg-red-700' : 'bg-green-700'}` }, isMuted ? 'Unmute' : 'Mute')));
}
export default TrackItem;
